import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input, TextArea, Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";

import { CardAtividade, Container } from "./styles";
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from "~/services/api";

function AtividadesList({ defaultData, setter, setterSoma, setterSomaLib, gerarProjeto }) {
  const atividadePad = [
    { item: 1, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Gestão do projeto", descricao: "", horaTotal: 0, horaSaldo: 0, horaUsada: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", horasPorDia: 8, horaInicial: "00:00", horaFinal: "00:00", dataEntregaProjeto: "", travarSaldo: "S", analistas: [] },
    { item: 2, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Especificação", descricao: "", horaTotal: 0, horaSaldo: 0, horaUsada: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", horasPorDia: 8, horaInicial: "00:00", horaFinal: "00:00", dataEntregaProjeto: "", travarSaldo: "S", analistas: [] },
    { item: 3, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Desenvolvimento", descricao: "", horaTotal: 0, horaSaldo: 0, horaUsada: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", horasPorDia: 8, horaInicial: "00:00", horaFinal: "00:00", dataEntregaProjeto: "", travarSaldo: "S", analistas: [] },
    { item: 4, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Validar as rotinas em ambiente de homologação", descricao: "", horaTotal: 0, horaSaldo: 0, horaUsada: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", horasPorDia: 8, horaInicial: "00:00", horaFinal: "00:00", dataEntregaProjeto: "", travarSaldo: "S", analistas: [] },
    { item: 5, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Atualizar a base de produção - GoLive", descricao: "", horaTotal: 0, horaSaldo: 0, horaUsada: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", horasPorDia: 8, horaInicial: "00:00", horaFinal: "00:00", dataEntregaProjeto: "", travarSaldo: "S", analistas: [] },
    { item: 6, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Acompanhar pós - GoLive", descricao: "", horaTotal: 0, horaSaldo: 0, horaUsada: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", horasPorDia: 8, horaInicial: "00:00", horaFinal: "00:00", dataEntregaProjeto: "", travarSaldo: "S", analistas: [] },
    { item: 7, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Reunião de encerramento", descricao: "", horaTotal: 0, horaSaldo: 0, horaUsada: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", horasPorDia: 8, horaInicial: "00:00", horaFinal: "00:00", dataEntregaProjeto: "", travarSaldo: "S", analistas: [] },
  ];
  const [atividades, setAtividades] = useState([]);
  const [analistas, setAnalistas] = useState([]);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/gerencia/analistas").then((r) => setAnalistas(r?.data));
  }, []);

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        if (edit) {
          let aAtividade = [];
          let item = 1;
          for (const itemAtividade of defaultData) {
            let analistas = [];

            if (itemAtividade?.itensAtividade && itemAtividade?.itensAtividade?.length > 0) {
              for (const itemItens of itemAtividade?.itensAtividade) {
                analistas.push({
                  id: itemItens?.id,
                  horaTotal: itemItens?.horaTotal,
                  horaSaldo: itemItens?.horaSaldo,
                  horaUsada: itemItens?.horaUsada,
                  titulo: itemItens?.titulo,
                  descricao: itemItens?.descricao,
                  idAnalista: itemItens?.idAnalista,
                  previsaoInicio: itemItens?.previsaoInicio,
                  dataInicio: itemItens?.dataInicio,
                  previsaoEntrega: itemItens?.previsaoEntrega,
                  dataEntrega: itemItens?.dataEntrega,
                  idProjetoAtividadeAnalista: itemItens?.analistaAtividade?.id,
                  responsabilidade: itemItens?.responsabilidade,
                  statusTarefa: itemItens?.statusTarefa,
                  percentualEvolucao: itemItens?.percentualEvolucao,
                  exibeMapa: itemItens?.exibeMapa,
                });
              }
            }

            // for (const itemAnal of itemAtividade?.analistasAtividade) {
            //   if (!itemAnal?.idProjetoAtividadeItem || itemAnal?.idProjetoAtividadeItem == 0) {
            //     analistas.push({
            //       id: 0,
            //       horaTotal: itemAnal?.horaTotal,
            //       horaSaldo: itemAnal?.horaSaldo,
            //       horaUsada: itemAnal?.horaUsadaReal,
            //       titulo: itemAtividade?.titulo,
            //       descricao: itemAtividade?.descricao,
            //       idAnalista: itemAnal?.idAnalista,
            //       previsaoInicio: itemAtividade?.previsaoInicio,
            //       dataInicio: itemAtividade?.dataInicio,
            //       previsaoEntrega: itemAtividade?.previsaoEntrega,
            //       dataEntrega: itemAtividade?.dataEntrega,
            //       idProjetoAtividadeAnalista: itemAnal?.id,
            //     });
            //   }
            // }

            aAtividade.push({
              item,
              id: itemAtividade?.id,
              idDesc: item + (itemAtividade?.orcamento ? ` - SD ${itemAtividade?.orcamento?.id}` : ` - Sem SD`),
              titulo: itemAtividade?.titulo,
              descricao: itemAtividade?.descricao,
              horaTotal: itemAtividade?.horaTotal,
              horaSaldo: itemAtividade?.horaSaldo,
              horaUsada: itemAtividade?.horaUsadaReal,
              dataInicioProjeto: itemAtividade?.previsaoInicio,
              dataPrevEntregaProjeto: itemAtividade?.previsaoEntrega,
              dataEntregaProjeto: itemAtividade?.dataEntrega,
              horasPorDia: itemAtividade?.horasPorDia,
              horaInicial: itemAtividade?.horaInicial,
              horaFinal: itemAtividade?.horaFinal,
              travarSaldo: itemAtividade?.travarSaldo,
              exibeCronograma: itemAtividade?.exibeCronograma,
              abertoAtividade: false,
              analistas
            });

            item++;
          }
          setAtividades(aAtividade);
          setter(aAtividade);
        }
      } else {
        if (!(edit && editShow)) {
          setAtividades(atividadePad);
          setter(atividadePad);
        }
      }
    }
  }, [edit, editShow]);

  useEffect(() => {
    setter(atividades);

    if (setterSoma && setterSomaLib) {
      let horaTotal = 0;
      let horaSaldo = 0;
      for (const item of atividades) {
        horaTotal += item?.horaTotal;
        horaSaldo += item?.horaSaldo;
      }

      setterSoma(horaTotal);
      setterSomaLib(horaSaldo);
    }
  }, [atividades]);

  function handleAddAtividade() {
    setAtividades((prev) => [...prev, { item: (atividades?.length > 0 ? atividades[atividades?.length - 1]?.item + 1 : 1), id: 0, abertoAtividade: false, idDesc: "0 - Sem SD", titulo: "Atividade de Projeto", descricao: "", horaTotal: 0, horaSaldo: 0, horaUsada: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", horasPorDia: 8, horaInicial: "00:00", horaFinal: "00:00", dataEntregaProjeto: "", travarSaldo: "", analistas: [] }]);
  }

  function handleRemoveAtividade(data) {
    setAtividades((prev) => {
      const newPrev = [...prev];
      const checkIndex = prev.findIndex((e) => e?.item === data?.item);

      if (checkIndex >= 0) {
        newPrev.splice(checkIndex, 1);
      }

      return newPrev;
    });
  }

  function handleAddAnalista(index) {
    setAtividades((prev) => {
      let newPrev = [...prev];
      let analistas = [];
      let horaTotal = 0;

      for (const itemAnal of newPrev[index].analistas) {
        horaTotal += itemAnal?.horaTotal;
        analistas.push(itemAnal);
      }
      // newPrev[index].horaTotal = (horaTotal > 0 ? horaTotal : newPrev[index].horaTotal);

      // analistas.push({ id: 0, horaTotal: (analistas.length > 0 ? 0 : newPrev[index].horaTotal), horaSaldo: 0, horaUsada: 0 });

      analistas.push({
        id: 0,
        horaTotal: (analistas.length > 0 ? 0 : newPrev[index].horaTotal),
        horaSaldo: 0,
        horaUsada: 0,
        titulo: "",
        descricao: "",
        idAnalista: 0,
        previsaoInicio: "",
        dataInicio: "",
        previsaoEntrega: "",
        dataEntrega: "",
        idProjetoAtividadeAnalista: 0,
      });
      newPrev[index].analistas = analistas;

      return newPrev;
    });
  }

  function handleRemoveAnalista(index, iAnal) {
    setAtividades((prev) => {
      const newPrev = [...prev];
      let analistas = [];
      let count = 0;
      let horaTotal = 0;
      let horaSaldo = 0;

      for (const itemAnal of newPrev[index].analistas) {
        if (count != iAnal) {
          horaTotal += itemAnal?.horaTotal;
          horaSaldo += itemAnal?.horaSaldo;
          analistas.push(itemAnal);
        }

        count++;
      }

      newPrev[index].analistas = analistas;
      // newPrev[index].horaTotal = horaTotal;
      newPrev[index].horaSaldo = horaSaldo;

      return newPrev;
    });
  }

  return (
    <Container>
      <Label title="Atividades *" className="titulo-label" row={true}>
        {!(editShow && edit) ? (
          <ColoredButton small blueLayout type="button" onClick={handleAddAtividade}>
            Adicionar
          </ColoredButton>
        ) : (
          <ColoredButton small disabledLayout type="button">
            Adicionar
          </ColoredButton>
        )}
      </Label>
      <CardAtividade>
        <div className="card-atv-header">
          <div className="titulos-tab">
            <div className="w1">
              <div className="top-header">
                -
              </div>
            </div>
            <div className="atividade">
              <p className="titulo">Título <span>*</span></p>
            </div>
            <div className="data-prev-inicio">
              <p className="titulo">Prev Inicio <span></span></p>
            </div>
            <div className="data-prev-entrega">
              <p className="titulo">Prev Entrega <span></span></p>
            </div>
            <div className="data-entrega">
              <p className="titulo">Real Entrega <span></span></p>
            </div>
            <div className="hora-total">
              <p className="titulo">Hora Total <span>*</span></p>
            </div>
            <div className="hora-lib">
              <p className="titulo">Hora Lib <span></span></p>
            </div>
            <div className="hora-lib">
              <p className="titulo">Hora Usada <span></span></p>
            </div>
            <div className="hora-dia">
              <p className="titulo">Horas Por Dia <span>*</span></p>
            </div>
            <div className="hora-lib">
              <p className="titulo">Exibe Cronog. <span>*</span></p>
            </div>
            <div className="desc">
              <p className="titulo">Anotações</p>
            </div>
          </div>
        </div>
        {atividades?.map((itemData, index) => (
          <div className="card-atv-body">
            <div className="row no-margin row-top">
              <div className="w1">
                <div className="top-header">
                  <div onClick={(e) => { handleRemoveAtividade(itemData) }} className="icon-button material-icons">delete</div>
                  <div
                    onClick={(e) => {
                      setAtividades((prev) => {
                        let newPrev = [...prev];

                        newPrev[index].abertoAtividade = !newPrev[index].abertoAtividade;

                        return newPrev;
                      });
                    }}
                    className="icon-button material-icons"
                  >
                    description
                  </div>
                </div>
              </div>
              <div className="w2">
                <Input
                  placeholder="Titulo da Atividade"
                  name="tituloAtividadeAt"
                  required="true"
                  value={itemData?.titulo}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].titulo = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="date"
                  name="dataInicioProjetoAt"
                  value={itemData?.dataInicioProjeto}
                  required={false}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].dataInicioProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="date"
                  name="dataPrevEntregaProjetoAt"
                  min={itemData?.dataInicioProjeto}
                  required={false}
                  value={itemData?.dataPrevEntregaProjeto}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].dataPrevEntregaProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="date"
                  name="dataEntregaProjetoAt"
                  required={false}
                  value={itemData?.dataEntregaProjeto}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].dataEntregaProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="number"
                  name="horaTotalAt"
                  min="1"
                  required="true"
                  value={itemData?.horaTotal}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].horaTotal = parseInt(v);

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="number"
                  name="horaSaldoAt"
                  step="0.10"
                  required="true"
                  disabled="true"
                  value={itemData?.horaSaldo}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].horaSaldo = parseFloat(v);

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="number"
                  name="horaUsadaAt"
                  step="0.10"
                  required="true"
                  disabled="true"
                  value={itemData?.horaUsada}
                />
              </div>
              <div className="w4">
                <Input
                  type="number"
                  name="horasPorDiaAt"
                  min="1"
                  max="24"
                  required="true"
                  value={itemData?.horasPorDia}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].horasPorDia = parseInt(v);

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Select
                  required="true"
                  isString
                  list={{ list: [{ id: "S", titulo: "Sim" }, { id: "N", titulo: "Não" }], value: "id", label: "titulo" }}
                  name="exibeCronogramaAt"
                  defaultValue={itemData?.exibeCronograma}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "S";
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].exibeCronograma = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w5">
                <TextArea
                  placeholder="Anotações da Atividade"
                  name="descAtividadeAt"
                  value={itemData?.descricao}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].descricao = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
            </div>
            {itemData?.abertoAtividade && (
              <div className="sub-atividade">
                <div className="card-sub-atv-header">
                  <div className="titulos-tab">
                    <div className="w1">
                      <div className="add-header">
                        {!(editShow && edit) ? (
                          <ColoredButton small blueLayout type="button" onClick={() => { handleAddAnalista(index) }}>
                            +
                          </ColoredButton>
                        ) : (
                          <ColoredButton small disabledLayout type="button">
                            +
                          </ColoredButton>
                        )}
                      </div>
                    </div>
                    <div className="atividade">
                      <p className="titulo">Título Tarefa <span>*</span></p>
                    </div>
                    <div className="hora-lib">
                      <p className="titulo">Hora Lib <span>*</span></p>
                    </div>
                    <div className="hora-lib">
                      <p className="titulo">Hora Usada <span>*</span></p>
                    </div>
                    <div className="hora-final">
                      <p className="titulo">Analista <span>*</span></p>
                    </div>
                    <div className="data-prev-inicio">
                      <p className="titulo">Prev Inicio <span>*</span></p>
                    </div>
                    <div className="data-prev-entrega">
                      <p className="titulo">Prev Entrega <span>*</span></p>
                    </div>
                    <div className="data-entrega">
                      <p className="titulo">Data Entrega</p>
                    </div>
                    <div className="data-entrega">
                      <p className="titulo">Responsabilidade</p>
                    </div>
                    <div className="data-entrega">
                      <p className="titulo">Status Tarefa</p>
                    </div>
                    <div className="data-entrega">
                      <p className="titulo">Exibe no Mapa</p>
                    </div>
                    <div className="data-entrega">
                      <p className="titulo">% Evolução</p>
                    </div>
                    <div className="desc">
                      <p className="titulo">Descrição</p>
                    </div>
                  </div>
                </div>
                {itemData?.analistas?.map((itemAtividade, indexAtividade) => (
                  <div className="row no-margin row-top">
                    <div className="w1">
                      <div className="top-header">
                        {itemAtividade?.horaUsadaReal == 0 || !itemAtividade?.horaUsadaReal ? (<div onClick={(e) => { handleRemoveAnalista(index, indexAtividade) }} className="icon-button material-icons">delete</div>) : <div />}
                      </div>
                    </div>
                    <div className="w2">
                      <Input
                        placeholder="Titulo da Tarefa"
                        name="tituloTarefaAt"
                        required="true"
                        value={itemAtividade?.titulo}
                        {...{ ...(itemAtividade?.id == 0 && itemAtividade?.idProjetoAtividadeAnalista != 0 ? { disabled: true } : {}) }}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "";
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.analistas) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, titulo: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="number"
                        name="horaSaldoTarefaAt"
                        step="0.10"
                        required="true"
                        value={itemAtividade?.horaSaldo}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            const newPrev = [...prev];
                            let analistas = [];
                            let count = 0;
                            let horaSaldo = 0;

                            for (const itemAnal of newPrev[index]?.analistas) {
                              if (count == indexAtividade) {
                                horaSaldo += parseInt(v);
                                analistas.push({ ...itemAnal, horaSaldo: parseInt(v) });
                              } else {
                                horaSaldo += itemAnal?.horaSaldo;
                                analistas.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = analistas;
                            newPrev[index].horaSaldo = horaSaldo;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="number"
                        name="horaUsadaTarefaAt"
                        step="0.10"
                        required="true"
                        disabled="true"
                        value={itemAtividade?.horaUsada}
                      />
                    </div>
                    <div className="w4">
                      <Select
                        isString
                        list={{ list: analistas, value: "id", label: "nome" }}
                        name={"idAnalista" + indexAtividade}
                        firstOption
                        required="true"
                        {...{ ...(itemAtividade?.idProjetoAtividadeAnalista == 0 ? {} : { disabled: true }) }}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            const newPrev = [...prev];
                            let analistas = [];
                            let count = 0;

                            for (const itemAtividade of newPrev[index].analistas) {
                              if (count == indexAtividade) {
                                analistas.push({ ...itemAtividade, idAnalista: parseInt(v) });
                              } else {
                                analistas.push(itemAtividade);
                              }

                              count++;
                            }
                            newPrev[index].analistas = analistas;

                            return newPrev;
                          });
                        }}
                        value={itemAtividade?.idAnalista}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="date"
                        name="previsaoInicioTarefaAt"
                        value={itemAtividade?.previsaoInicio}
                        min={itemData?.previsaoInicioProjeto}
                        max={itemData?.dataPrevEntregaProjeto}
                        {...{ ...(itemAtividade?.id == 0 && itemAtividade?.idProjetoAtividadeAnalista != 0 ? { disabled: true } : {}) }}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.analistas) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, previsaoInicio: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="date"
                        name="previsaoEntregaTarefaAt"
                        value={itemAtividade?.previsaoEntrega}
                        min={itemAtividade?.previsaoInicio}
                        max={itemData?.dataPrevEntregaProjeto}
                        {...{ ...(itemAtividade?.id == 0 && itemAtividade?.idProjetoAtividadeAnalista != 0 ? { disabled: true } : {}) }}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.analistas) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, previsaoEntrega: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="date"
                        name="dataEntregaTarefaAt"
                        value={itemAtividade?.dataEntrega}
                        {...{ ...(itemAtividade?.id == 0 && itemAtividade?.idProjetoAtividadeAnalista != 0 ? { disabled: true } : {}) }}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.analistas) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, dataEntrega: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Select
                        required="true"
                        isString
                        list={{ list: [{ id: "E", titulo: "Erpworks" }, { id: "C", titulo: "Cliente" }], value: "id", label: "titulo" }}
                        name="responsabilidadeAt"
                        defaultValue={itemAtividade?.responsabilidade}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "E";
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.analistas) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, responsabilidade: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Select
                        required="true"
                        isString
                        list={{ list: [{ id: "N", titulo: "Não Iniciado" }, { id: "E", titulo: "Em Execução" }, { id: "C", titulo: "Concluído" }], value: "id", label: "titulo" }}
                        name="statusTarefaAt"
                        defaultValue={itemAtividade?.statusTarefa}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "N";
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.analistas) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, statusTarefa: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Select
                        required="true"
                        isString
                        list={{ list: [{ id: "N", titulo: "Não" }, { id: "S", titulo: "Sim" }], value: "id", label: "titulo" }}
                        name="exibeMapaAt"
                        defaultValue={itemAtividade?.exibeMapa}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "N";
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.analistas) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, exibeMapa: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="number"
                        name="percentualEvolucaoTarefaAt"
                        step="0.10"
                        max="100"
                        min="1"
                        required="true"
                        value={itemAtividade?.percentualEvolucao}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.analistas) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, percentualEvolucao: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w5">
                      <TextArea
                        placeholder="Descrição da Atividade"
                        name="descricaoTarefaAt"
                        value={itemAtividade?.descricao}
                        {...{ ...(itemAtividade?.id == 0 && itemAtividade?.idProjetoAtividadeAnalista != 0 ? { disabled: true } : {}) }}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "";
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.analistas) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, descricao: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </CardAtividade>
      {/* ))} */}
    </Container>
  );
}

export default AtividadesList;
